/**
 * 免费模板-主首页筛选分类模板列表状态定义与同步
 */

import ACTIONS from 'constants/action.json5';

const initialState = {};

export default (state = initialState, action) => {
  switch (action.type) {
    case ACTIONS.GET_FILTERS_TPLS_SUCCEED: {
      const { tpls, filterKey } = action.payload;
      const { key } = filterKey;
      return {
        ...state,
        [key]: { ...filterKey, tpls },
      };
    }
    default:
      return state;
  }
};
